import React from 'react'
import purify from 'dompurify'

const SanitizedHtml = ({ html = '' }) =>
  html ? <div dangerouslySetInnerHTML={{ __html: purify.sanitize(html) }} /> : null

export default React.memo(SanitizedHtml)
